import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FunctionComponent } from 'react';
import { ultraTableStyles } from '../../styles/ultratable.styles';
import { Tooltip } from '@mui/material';

interface PortalToolsProps {
  toolBarBtns?: JSX.Element[];
}

const PortalTools: FunctionComponent<PortalToolsProps> = ({ toolBarBtns }) => {
  const classes = ultraTableStyles();

  return (
    <Popover as="div" className="relative">
      <Tooltip
        classes={{ tooltip: classes.columnHeadTooltip }}
        title="More tools"
        placement="top"
        enterDelay={500}
      >
        <PopoverButton className="group flex h-10 w-10 items-center justify-center rounded-full bg-white p-2 transition duration-200 ease-in-out hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-mainblue/50 active:bg-gray-100">
          <MoreVertIcon className="size-5 text-gray-400 transition duration-200 ease-in-out active:text-gray-300 group-hover:text-gray-800" />
        </PopoverButton>
      </Tooltip>

      <PopoverPanel
        anchor="bottom start"
        className="absolute right-0 z-[9999] mt-2 w-fit origin-top-right rounded-xl border border-black/5 bg-white p-1 text-sm/6 text-black shadow-lg focus:outline-none"
      >
        <div className="flex items-center gap-1">
          {toolBarBtns?.map((child, i) => (
            <div key={i}>{child}</div>
          ))}
        </div>
      </PopoverPanel>
    </Popover>
  );
};

export default PortalTools;
